import client from './api-client';

export const getConfiguracionForm27 = async(query) => {
    try {
        
        const response = await client.getSelect(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form27: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosAntecedentes = async(query) => {
    try {
        
        const response = await client.getSelect(`gestion-implicado/antec-judiciales?q=${query}`); 
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosAntecedentes: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosGrilla = async(query) => {
    try {
        
        const response = await client.getSelect(`gestion-implicado/contacto/hitos?q=${query}`);    
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGrilla: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
